// CJ Affiliate (Commission Junction) tracking link generator
// Sign up at cj.com → apply to Ticketmaster program → get PID + AID
//
// Add to .env:
//   VITE_CJ_PUBLISHER_ID=your_publisher_id
//   VITE_CJ_ADVERTISER_ID=ticketmaster_advertiser_id (usually ~3696889)

const CJ_PID = import.meta.env.VITE_CJ_PUBLISHER_ID || '';
const CJ_AID = import.meta.env.VITE_CJ_ADVERTISER_ID || '';

// CJ deep-link tracking domain (they rotate, tkqlhce is most stable)
const CJ_DOMAIN = 'https://www.tkqlhce.com';

export function affiliateTicketUrl(originalUrl: string): string {
  if (!CJ_PID || !CJ_AID || !originalUrl) return originalUrl;
  return `${CJ_DOMAIN}/click-${CJ_PID}-${CJ_AID}?url=${encodeURIComponent(originalUrl)}`;
}

export function hasAffiliateSetup(): boolean {
  return !!(CJ_PID && CJ_AID);
}
